import { z } from 'zod'

export const HealthResponse = z.object({
  ok: z.boolean(),
  version: z.string(),
  ts: z.string(),
  deps: z.object({ db: z.boolean(), redis: z.boolean() }),
})
export type HealthResponse = z.infer<typeof HealthResponse>

export const PlayerVariant = z.enum(['ai', 'written'])
export type PlayerVariant = z.infer<typeof PlayerVariant>

export const SessionResponse = z.object({ playerId: z.uuid(), variant: PlayerVariant })
export type SessionResponse = z.infer<typeof SessionResponse>

export const ApiErrorBody = z.object({ error: z.string(), message: z.string().optional() })
export type ApiErrorBody = z.infer<typeof ApiErrorBody>
